<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Wybór koloru</p>
			<button
				type="button"
				class="delete"
				aria-label="close"
				@click="$parent.$emit('close')"
			></button>
		</header>
		<section class="modal-card-body">
			<div class="colors">
				<!-- <a :class="[ 'color', { selected: color.hex === selected.hex } ]" v-for="color in colors" :key="color.name" @click.prevent="selected = color"> -->
				<a
					:class="['color', { selected: color.hex === selected.hex }]"
					v-for="color in colors"
					:key="color.name"
					@click.prevent="select(color)"
				>
					<span class="color__preview" :style="getTagStyle(color.hex)"></span>
					<span class="color__name">{{ color.name }}</span>
				</a>
			</div>
			<hr />
			<p>
				Wybrany kolor: <b>{{ selected.name }}</b>
			</p>
		</section>
		<!-- <footer class="modal-card-foot">
      <button type="button" class="button is-success" @click.prevent="$parent.$emit('select', selected)">Wybierz</button>
      <button class="button is-white" type="button" @click="$parent.$emit('close')">Zamknij</button>
    </footer> -->
	</div>
</template>

<script>
export default {
	name: 'ColorPicker',
	props: {
		preselected: {
			required: false,
			type: Object
		}
	},
	data() {
		return {
			selected: null,
			colors: [
				{ name: 'zielony', hex: '#B0BF1A' },
				{ name: 'jasny zielony', hex: '#90EE90' },
				{ name: 'ciemny zielony', hex: '#008443' },
				{ name: 'niebieski', hex: '#1974D2' },
				{ name: 'jasny niebieski', hex: '#7CB9E8' },
				{ name: 'ciemny niebieski', hex: '#0048BA' },
				{ name: 'czerwony', hex: '#D92121' },
				{ name: 'jasny czerwony', hex: '#FFCCCB' },
				{ name: 'ciemny czerwony', hex: '#8B0000' },
				{ name: 'żółty', hex: '#FADA5E' },
				{ name: 'jasny żółty', hex: '#FFFF9F' },
				{ name: 'ciemny żółty', hex: '#EEDC82' },
				{ name: 'różowy', hex: '#F64A8A' },
				{ name: 'jasny różowy', hex: '#FFB6C1' },
				{ name: 'ciemny różowy', hex: '#E75480' },
				{ name: 'pomarańczowy', hex: '#FFBF00' },
				{ name: 'jasny pomarańczowy', hex: '#FED8B1' },
				{ name: 'ciemny pomarańczowy', hex: '#FF8C00' },
				{ name: 'brak', hex: '#CCCCCC' }
			]
		}
	},
	methods: {
		getTagStyle(color) {
			return `background-color: ${color};`
		},
		select(color) {
			this.$emit('select', color)
			this.$parent.$emit('close')
		}
	},
	created() {
		this.selected = this.preselected ? this.preselected : this.colors[this.colors.length - 1]
	}
}
</script>

<style lang="scss" scoped>
.modal-card {
	.colors {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
	}
	.color {
		display: flex;
		flex: 1 0 calc(100% / 6 - 20px);
		flex-direction: column;
		text-align: center;
		margin: 10px;
		border: 1px solid #ccc;
		border-radius: 3px;
		transition: 0.1s;
		height: 85px;
		&:hover {
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
			transform: scale(1.05);
		}
		&.selected {
			border: 1px solid red;
			background-color: rgba(255, 0, 0, 0.05);
		}
		&:last-child {
			margin-right: 100%;
		}
		&__preview {
			height: 50px;
			display: block;
			margin: 5px 5px 0;
		}
		&__name {
			font-size: 14px;
			padding: 5px 10px;
			color: #000;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.mdi {
		font-size: 40px;
	}
}
</style>
